/*============================================================================
  DELIVERY ESTIMATION
==============================================================================*/

(function () {

  var initialize = function (moment) {
    moment.fn.easterDay = moment.fn.paques = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      var a = Y % 19;
      var b = Math.floor(Y / 100);
      var c = Y % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var n0 = (h + l + 7 * m + 114);
      var n = Math.floor(n0 / 31) - 1;
      var p = n0 % 31 + 1;
      var date = new Date(Y, n, p);
      return moment(date);
    };

    moment.fn.lundiDePaques = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment.fn.paques(Y).add(1, "days");
    };

    moment.fn.ascension = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment.fn.paques(Y).add(39, "days");
    };

    moment.fn.pentecote = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment.fn.paques(Y).add(50, "days");
    };

    moment.fn.jourDeLAn = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("1-1-" + Y, "DD-MM-YYYY");
    };

    moment.fn.feteDuTravail = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("1-5-" + Y, "DD-MM-YYYY");
    };

    moment.fn.victoireDeAllies = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("8-5-" + Y, "DD-MM-YYYY");
    };

    moment.fn.feteNationale = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("14-7-" + Y, "DD-MM-YYYY");
    };

    moment.fn.assomption = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("15-8-" + Y, "DD-MM-YYYY");
    };

    moment.fn.toussaint = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("1-11-" + Y, "DD-MM-YYYY");
    };

    moment.fn.armistice = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("11-11-" + Y, "DD-MM-YYYY");
    };

    moment.fn.noel = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("25-12-" + Y, "DD-MM-YYYY");
    };

    var listeFerie = {
      "Jour de l'an": moment.fn.jourDeLAn,
      "Fête du travail": moment.fn.feteDuTravail,
      "Victoire des alliés": moment.fn.victoireDeAllies,
      "Fête Nationale": moment.fn.feteNationale,
      "Assomption": moment.fn.assomption,
      "Toussaint": moment.fn.toussaint,
      "Armistice": moment.fn.armistice,
      "Noël": moment.fn.noel,
      "Pâques": moment.fn.paques,
      "Lundi de Pâques": moment.fn.lundiDePaques,
      "Ascension": moment.fn.ascension,
      "Pentecôte": moment.fn.pentecote
    };

    moment.fn.getFerieList = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }

      var res = [];
      for (var key in listeFerie) {
        if (listeFerie.hasOwnProperty(key)) {
          res.push({ name: key, date: listeFerie[key](Y) });
        }
      }
      return res;
    };

    moment.fn.getFerie = function () {
      for (var key in listeFerie) {
        if (listeFerie.hasOwnProperty(key)) {
          if (this.isSame(listeFerie[key].call(this), 'days')) {
            return key;
          }
        }
      }
      return null;
    };

    moment.fn.isFerie = function () {
      return (this.getFerie() !== null);
    };

    // Weekend = only Sunday because Chronopost deliver on Saturday
    moment.fn.isWeekEndDelivery = function () {
      return (this.day() === 0);
    };

    // Weekend ADDAXA/Plaquadom = Saturday and Sunday
    moment.fn.isWeekEndAddaxa = function () {
      return (this.day() === 0 || this.day() === 6);
    };

    moment.fn.isWorkingDayDelivery = function () {
      return (!this.isWeekEndDelivery() && !this.isFerie());
    };

    moment.fn.isWorkingDayAddaxa = function () {
      return (!this.isWeekEndAddaxa() && !this.isFerie());
    };

    return moment;
  };

  if (typeof define === "function" && define.amd) {
    define("moment-ferie-fr", ["moment"], function (moment) {
      return this.moment = initialize(moment);
    });
  } else if (typeof module !== "undefined") {
    module.exports = initialize(require("moment"));
  } else if (typeof window !== "undefined" && window.moment) {
    this.moment = initialize(this.moment);
  }
}).call(this);

var deliveryEstimation = {
  COLISOMO_DAY: 2,
  CHRONOPOST_DAY: 1,
  VALIDE_VENDOR: ["Plaque deces", "Plaquadom", "Graniflor", "Fixings"],
  products: [],

  initDeliveryCart: function () {
    this.products = popstampStore.products;
    if (this.products.length > 0) {
      this.products = popstampStore.products;
      this._cleanCardsItem();
      
      // Ensure locale is set before formatting
      this._setMomentLocale();
      
      var delivery = deliveryEstimation.getEstimatedDelivery();
      const chronopost = document.getElementById('chronopost')
      const colissimo = document.getElementById('colissimo')
      if (chronopost) chronopost.innerHTML = delivery.chronopost.format('DD MMM');
      if (colissimo) colissimo.innerHTML = delivery.colissimo.from.format('DD MMM');
      // document.getElementById('chronopost').innerHTML = delivery.chronopost.format('dddd DD MMM');
      // document.getElementById('colissimo').innerHTML = delivery.colissimo.from.format('dddd DD MMM');
    }
  },

  initDeliveryProduct: function () {
    this.products = popstampStore.products;
    
    // Ensure locale is set before formatting
    this._setMomentLocale();
    
    var delivery = deliveryEstimation.getEstimatedDelivery();
    $('.delivery-estimate').html(delivery.chronopost.format('dddd DD MMM'));
  },

  _setMomentLocale: function () {
    if (popstampStore.lang && typeof moment !== 'undefined') {
      moment.locale(popstampStore.lang);
      // console.info('Moment locale set to:', langCode, '| Current locale:', moment.locale());
    }
  },

  getEstimatedDelivery: function () {
    var today = moment();

    if (!today.isWorkingDayAddaxa()) {
      //As long the day is not a working day -> go to the next day
      while (!today.isWorkingDayAddaxa()) {
        today.add(1, "days");
      }
      // Exemple : order on Friday 11pm -> set hours to 0 to be produce before 8am on Monday
      today.hours(0);
    }

    this._addProductionDays(today);

    return {
      colissimo: this._getDateRangeDeliveryColissimo(today),
      chronopost: this._getDateDeliveryChronopost(today),
    };
  },

  _addProductionDays: function (expeditionDate) {
    // production tomorrow if after 8am
    if (expeditionDate.hours() >= 8) {
      this._addDays(expeditionDate, 1, true);
    }
    // 3 days of production for Plaquadom
    if (this._isCartContainsPlaquaDom()) {
      this._addDays(expeditionDate, 2, true);
    }
  },

  _getDateRangeDeliveryColissimo: function (expeditionDate) {
    var from = this._addDays(moment(expeditionDate), this.COLISOMO_DAY); // 48h
    var to = this._addDays(moment(expeditionDate), this.COLISOMO_DAY + 1); // 72h
    return {
      from,
      to,
    };
  },

  _getDateDeliveryChronopost: function (expeditionDate) {
    return this._addDays(moment(expeditionDate), this.CHRONOPOST_DAY);
  },

  _addDays: function (date, nbDays, isWorkingDayAddaxa) {
    while (nbDays > 0) {
      date.add(1, "days");
      var isWorkingDay = isWorkingDayAddaxa
        ? date.isWorkingDayAddaxa()
        : date.isWorkingDayDelivery();
      if (isWorkingDay) {
        nbDays--;
      }
    }
    return date;
  },

  _isCartContainsPlaquaDom: function () {
    return this.products.includes("Plaquadom");
  },

  //Remove bat, maquette etc
  _cleanCardsItem: function () {
    var self = this;
    this.products = this.products.filter(function (product) {
      return self.VALIDE_VENDOR.includes(product)
    });
  },
};

window.addEventListener('load', () => {
  deliveryEstimation.initDeliveryProduct();
  deliveryEstimation.initDeliveryCart();
})